module.exports = __webpack_public_path__ + "static/media/gin.83f65c6f.svg";